import { Link } from "react-router-dom";
import Container from "./Container";
import { logo } from "../assets/home";
import { useSiteContent } from "../context/SiteContentContext";

const isExternalLink = (url) => /^(https?:|mailto:|tel:)/i.test(url);
const isFacebookLink = (url) => /facebook\.com/i.test(url);

function FacebookIcon() {
  return (
    <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#1877f2] text-white shadow-[0_8px_20px_rgba(24,119,242,0.28)]">
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-3 w-3 fill-current">
        <path d="M13.5 21v-7h2.3l.3-2.7h-2.6V9.6c0-.8.2-1.3 1.4-1.3H16V5.9c-.2 0-.9-.1-1.8-.1-1.8 0-3 1.1-3 3.2v2.3H9v2.7h2.3v7h2.2Z" />
      </svg>
    </span>
  );
}

export default function Footer() {
  const { footer } = useSiteContent();

  return (
    <footer className="bg-[#212121] py-14 text-white">
      <Container>
        <div className="grid grid-cols-1 place-items-center gap-8 text-center sm:place-items-start sm:text-right md:grid-cols-[auto_1fr] md:items-start">
          <img src={logo} alt={footer.logoAlt} className="h-14 w-44" />

          <div>
            <h1 className="pb-4 font-bold">{footer.connectTitle}</h1>
            <ul className="space-y-2">
              {footer.links.map((link) => (
                <li key={`${link.label}-${link.url}`}>
                  {isExternalLink(link.url) ? (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-white/85 transition-colors hover:text-white"
                    >
                      {isFacebookLink(link.url) ? <FacebookIcon /> : null}
                      <span>{link.label}</span>
                    </a>
                  ) : (
                    <Link
                      to={link.url}
                      className="inline-flex items-center gap-2 text-white/85 transition-colors hover:text-white"
                    >
                      <span>{link.label}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </footer>
  );
}
